import moment from 'moment'
export default {
    name: 'dateHelper',
    displayDateTime : function(date) {
        return moment.utc(date).format("MM/DD/YYYY hh:mm a")
    }
};
